import { render } from "./register.vue?vue&type=template&id=1334c74f&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=1334c74f&lang=css"
import "./register.vue?vue&type=style&index=1&id=1334c74f&scoped=true&lang=css"
import "./register.vue?vue&type=style&index=2&id=1334c74f&lang=css"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1334c74f"]])

export default __exports__